import styled from 'styled-components';
import { blue } from '../../../utils/theme';

export const MenuToggle = styled.div`
  &:before,
  &::after {
    background: ${blue};
  }

  &:after {
    box-shadow: 0 -0.75rem 0 0 ${blue};
  }
`;



// WEBPACK FOOTER //
// ./src/components/menu-item/styles/menu-icon.style.js